"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logNewRelicPageAction = logNewRelicPageAction;
exports.logNewRelicError = logNewRelicError;
exports.reportMessage = reportMessage;
exports.reportError = reportError;
exports.getCurrentApp = getCurrentApp;
exports.serializeFileInfo = serializeFileInfo;

var _Raven = _interopRequireDefault(require("Raven"));

var _enviro = _interopRequireDefault(require("enviro"));

var NEW_RELIC_PAGE_ACTION_EVENT = 'FileManagerLibEvent';
var RAVEN_REQUEST_DATA_LENGTH_LIMIT = 1000;

var isDeployed = _enviro.default.deployed('sentry') || _enviro.default.deployed('newrelic');

var isDebug = Boolean(_enviro.default.debug('newrelic'));

function logNewRelicPageAction(eventName) {
  var attrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!(window.newrelic && window.newrelic.addPageAction)) {
    return;
  }

  if (isDebug) {
    console.log('[newrelic addPageAction]', eventName, attrs);
  }

  attrs.eventName = eventName;
  window.newrelic.addPageAction(NEW_RELIC_PAGE_ACTION_EVENT, attrs);
}

function logNewRelicError(error) {
  var attrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!(window.newrelic && window.newrelic.noticeError)) {
    return;
  }

  if (isDebug) {
    console.log('[newrelic noticeError]', error, attrs);
  }

  attrs.fromFileManager = true;
  window.newrelic.noticeError(error, attrs);
}

function reportMessage(message) {
  var extra = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  console.warn(message, extra);

  if (!isDeployed) {
    return;
  }

  _Raven.default.captureMessage(message, {
    extra: extra
  });

  logNewRelicPageAction('log', Object.assign({}, extra, {
    message: message
  }));
}

function reportError(err) {
  var extra = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  console.error(err);

  if (!isDeployed) {
    return;
  }

  var actionName = extra.action || extra.type || 'UNKNOWN';

  if (typeof err.status === 'number') {
    var tags = {
      status: err.status,
      errorCode: err.errorCode
    };

    if (err instanceof XMLHttpRequest) {
      var errorMessage = "Failed quickFetch request for " + actionName + " with status: " + err.status;
      logNewRelicPageAction('quickFetchFailure', Object.assign({}, extra, {}, tags, {
        isError: true
      }));

      _Raven.default.captureMessage(errorMessage, {
        tags: tags,
        extra: extra
      });
    } else if (err.options) {
      tags = Object.assign({}, tags, {
        requestUrl: err.options.url,
        requestMethod: err.options.method
      });

      var _errorMessage = "Failed hub-http request for " + actionName + " with status: " + err.status;

      logNewRelicPageAction('hubHttpFailure', Object.assign({}, extra, {}, tags, {
        isError: true
      }));

      if (err.options.data && typeof err.options.data === 'string') {
        extra.requestBody = err.options.data.substr(0, RAVEN_REQUEST_DATA_LENGTH_LIMIT);
      }

      if (typeof err.responseText === 'string') {
        extra.responseBody = err.responseText.substr(0, RAVEN_REQUEST_DATA_LENGTH_LIMIT);
      }

      _Raven.default.captureMessage(_errorMessage, {
        tags: tags,
        extra: extra
      });
    }

    return;
  }

  _Raven.default.captureException(err, {
    extra: extra
  });

  logNewRelicError(err.message || 'unknown', Object.assign({}, extra, {
    isError: true
  }));
}

function getCurrentApp() {
  return window.hubspot && window.hubspot.bender && window.hubspot.bender.currentProject;
}

function serializeFileInfo(file) {
  return {
    fileName: file.name,
    fileType: file.type,
    fileSize: file.size
  };
}